



































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { debounce } from "@/helpers/debounce";
import { useAsset, useDisabledSameMonth, useInternalContract } from "@/hooks";
import MNotificationVue from "@/mixins/MNotification.vue";
import {
  DATE_FORMAT_YYYY_MM_DD,
  DEFAULT_DATE_FORMAT,
} from "@/models/constants/date.constant";
import { Mode } from "@/models/enums/global.enum";
import { Messages } from "@/models/enums/messages.enum";
import { DataResponseListMasterAssetNotRent } from "@/models/interface/assets.interface";
import {
  AddressDataLines,
  ContactData,
  CustomAddressDataList,
} from "@/models/interface/contact.interface";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { DataWarehouseBranch } from "@/models/interface/logistic.interface";
import { AssetResponseDto } from "@/models/interface/master-asset";
import {
  DetailInternalContract,
  EnumStatus,
  RequestInternalContract,
} from "@/models/interface/salesOrder.interface";
import { DataMasterCurrency } from "@/models/interface/settings.interface";
import { IUserRole } from "@/models/interface/user.interface";
import { ColumnTableCustom } from "@/models/interface/util.interfase";
import { assetsServices } from "@/services/assets.service";
import { contactServices } from "@/services/contact.service";
import { logisticServices } from "@/services/logistic.service";
import { salesOrderServices } from "@/services/salesorder.service";
import { settingsServices } from "@/services/settings.service";
import {
  changeCurrencytoNumeric,
  currencyFormat,
  numericOnly,
} from "@/validator/globalvalidator";
import { Timeline } from "ant-design-vue";
import { UploadFile } from "ant-design-vue/types/upload";
import { Decimal } from "decimal.js-light";
import moment, { Moment } from "moment";
import Vue from "vue";
import { CustomDataSourceProductServiceTab } from "./ProductServiceTab.vue";

Vue.use(Timeline);
export interface DataRent {
  rentPeriod: number;
  startingDate: string;
}
export interface OptionBillingType {
  value: string;
  name: string;
}

export interface OptionCustom {
  name: string;
  option: any;
}

export interface DataSourceInternalContract {
  id: string;
  disabledInput?: boolean;
  disabledSelect?: boolean;
  disabledCheckBox?: boolean;
  optionCustom?: OptionCustom[];
  disableByRow?: string[];
  unitParentId: string | null;
  key?: number;
  idCategory?: string;
  endContract: boolean;
  closed: boolean;
  unitCode: string;
  unitCodeBackup: boolean;
  unitCodeBackupNo: string | number;
  equipment: string;
  merk: string;
  type: string;
  qty: string | number;
  uom: string;
  rentPrice: string | number;
  subTotal: string;
  serialNumber: string;
  specification: string;
  location: string;
  shipTo: string;
}

export interface FooterCreateInternalContract {
  total: number | string;
}

export interface DetailStatus {
  status: EnumStatus; // this status can change
  isAcceptanceOfOrder: boolean;
  isAllBastPosted: boolean;
  isSo: boolean;
  isCanCancel: boolean;
  actualStatusDocument: EnumStatus; // this status can change
}

export interface DataApprover {
  id: string;
  name: string;
}

export interface RentType {
  label: string;
  value: string;
}

const ACTION_TYPE = {
  NONE: "",
  DRAFT: "Draft",
  NEED_APPROVAL: "Need Approval",
  UPDATE: "Update",
  CHANGE_UNIT: "Change Unit",
  CHANGE_LOCATION: "Change Location",
  CHANGE_PRICE: "Change Price",
  CHANGE_PERIOD: "Change Period",
  HISTORY: "History",
  ENDED: "Ended",
  EXTEND: "Extend",
  APPROVE_REJECTED: "approve/rejected",
  REVISED: "Revised",
} as const;

export default Vue.extend({
  mixins: [MNotificationVue],
  components: {
    ProductServiceTab: () => import("./ProductServiceTab.vue"),
  },
  data() {
    return {
      mode: "" as string,
      defaultLocationShipTo: "" as string,
      defaultShipTo: "" as string,
      listRoles: [] as IUserRole[],
      detail: {
        status: EnumStatus.New, // this status can change
        isAcceptanceOfOrder: false,
        isAllBastPosted: false,
        isSo: false,
        isCanCancel: true,
        actualStatusDocument: EnumStatus.New,
      } as DetailStatus,
      idInternalContract: "" as string,
      InputNumberOnly: numericOnly,
      formatCurrencytoNumber: changeCurrencytoNumeric,
      tempColumnOption: [] as { name?: string; id?: string }[],
      modelForm: {
        date: [] as any,
      },
      dataRent: {
        rentPeriod: 0,
        startingDate: "",
      } as DataRent,
      footerCreateInternalContract: {
        total: 0,
      } as FooterCreateInternalContract,
      footerTotalProductServices: 0 as string | number,
      deleteLineId: [] as string[],
      deleteLineIdProductServices: [] as string[],
      urlForSend: "" as string,
      idBranch: "" as string,
      modalOpen: false as boolean,
      modalChangePeriodOpen: false as boolean,
      modalChangePriceOpen: false as boolean,
      modalChangeUnitOpen: false as boolean,
      replacementDateChangeUnit: "" as string,
      minDateChangeUnit: "" as string,
      actionType: "" as string,
      modeModal: "" as string,
      viewHistory: false as boolean,
      modalHistoryOpen: false as boolean,
      services: false as boolean,
      newRentPeriodRangeDisplay: "",
      formatCurrency: currencyFormat,
      // dataUnitCodeDefaultTable: [] as DataListMasterAsset[],
      // dataSource: [] as DataResponseGetStockAdjustment[],
      columnsTable: [
        {
          title: "Unit Code",
          dataIndex: "unitCode",
          key: "unitCode",
          width: 200,
          scopedSlots: { customRender: "unitCode" },
          fixed: "left",
          responsiveColSelect: [
            {
              name: "unitCode",
              placeholder: "Type for more data",
              style: "width: 100%;",
              disabled: false,
              value: "id",
              options: [] as DataResponseListMasterAssetNotRent[],
              loading: false,
              filterOption: "remote",
            },
            {
              name: "unitParentId",
              placeholder: "Type for more data",
              style: "width: 100%;",
              disabled: false,
              value: "id",
              options: [] as DataResponseListMasterAssetNotRent[],
              loading: false,
            },
            {
              name: "shipTo",
              placeholder: "Type for more data",
              style: "width: 100%;",
              disabled: false,
              value: "id",
              options: [] as CustomAddressDataList[],
              loading: false,
            },
          ],
          responsiveColInput: [
            {
              name: "qty",
              placeholder: "Qty Adjustment",
              style: "width: 100%",
              disabled: false,
            },
            {
              name: "rentPrice",
              placeholder: "Rent Price",
              style: "width: 100%",
              disabled: false,
            },
          ],
          responsiveColCheckBox: [
            {
              name: "endContract",
              disabled: true,
            },
            {
              name: "closed",
              disabled: true,
            },
            {
              name: "unitCodeBackup",
              disabled: false,
            },
          ],
        },
        {
          title: "Unit Code Backup",
          dataIndex: "unitCodeBackup",
          key: "unitCodeBackup",
          width: 140,
          scopedSlots: { customRender: "unitCodeBackup" },
          align: "center",
        },
        {
          title: "Ship To",
          dataIndex: "shipTo",
          key: "shipTo",
          width: 200,
          scopedSlots: { customRender: "shipTo" },
        },
        {
          title: this.$t("lbl_location"),
          dataIndex: "location",
          key: "location",
          width: 200,
          scopedSlots: { customRender: "location" },
        },
        {
          title: "Parent",
          dataIndex: "unitParentId",
          key: "unitParentId",
          width: 200,
          scopedSlots: { customRender: "unitParentId" },
        },
        {
          title: "Ended",
          dataIndex: "endContract",
          key: "endContract",
          width: 200,
          scopedSlots: { customRender: "endContract" },
        },
        {
          title: "Closed",
          dataIndex: "closed",
          key: "closed",
          width: 200,
          scopedSlots: { customRender: "closed" },
        },
        {
          title: "Unit Code Backup No",
          dataIndex: "unitCodeBackupNo",
          key: "unitCodeBackupNo",
          width: 160,
          align: "center",
        },
        {
          title: "Equipment",
          dataIndex: "equipment",
          key: "equipment",
          width: 150,
        },
        {
          title: "Merk",
          dataIndex: "merk",
          key: "merk",
          width: 150,
        },
        {
          title: "Type",
          dataIndex: "type",
          key: "type",
          width: 150,
        },
        {
          title: this.$t("lbl_serial_number"),
          dataIndex: "serialNumber",
          key: "serialNumber",
          width: 150,
        },
        {
          title: "Specification",
          dataIndex: "specification",
          key: "specification",
          width: 150,
        },
        {
          title: "Qty",
          dataIndex: "qty",
          key: "qty",
          width: 150,
          scopedSlots: { customRender: "qty" },
        },
        {
          title: "UOM",
          dataIndex: "uom",
          key: "uom",
          width: 150,
          scopedSlots: { customRender: "uom" },
        },
        {
          title: "Rent Price / Period",
          dataIndex: "rentPrice",
          key: "rentPrice",
          width: 250,
          scopedSlots: { customRender: "rentPrice" },
          align: "center",
        },
        {
          title: "SUB Total",
          dataIndex: "subTotal",
          key: "subTotal",
          width: 150,
        },
        {
          title: this.$root.$t("lbl_action").toString(),
          dataIndex: "operation",
          width: "120px",
          align: "center",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
          button: ["delete"],
        },
      ] as ColumnTableCustom[],
      loading: {
        listCustomer: false,
        branchName: false,
        status: false,
        revised: false,
        table: false,
        submit: false,
        shipTo: false,
        billTo: false,
        picName: false,
        currency: false,
        billingType: false,
        sales: false,
        submitFormModal: false,
        submitFormModalChangePeriod: false,
        submitFormModalChangePrice: false,
        submitFormModalChangeUnit: false,
        closeUnits: false,
      },
      DEFAULT_DATE_FORMAT,
      ACTION_TYPE,
      attachmentFile: "" as string,
      dataRentType: [
        {
          label: "Monthly",
          value: "Month",
        },
        {
          label: "Day",
          value: "Day",
        },
        {
          label: "3 Month",
          value: "3 Month",
        },
        {
          label: "6 Month",
          value: "6 Month",
        },
        {
          label: "Yearly",
          value: "Yearly",
        },
      ] as RentType[],
      rentType: "" as string,
      lastHistoryDate: "" as string,
      fileList: [] as UploadFile[],
      dataSource: [] as DataSourceInternalContract[],
      dataSourceProductServices: [] as CustomDataSourceProductServiceTab[],
      detailDataSourceProductServices:
        [] as CustomDataSourceProductServiceTab[], // this get from detail
      detailFooterTotalProductService: "" as string,
      selectedRowKeys: [] as number[],
      dataListCustomer: [] as ContactData[],
      dataListSales: [] as ContactData[],
      dataListBranch: [] as DataWarehouseBranch[],
      dataListRevised: [] as [],
      dataShipTo: [] as CustomAddressDataList[],
      dataBillTo: [] as CustomAddressDataList[],
      dataPicName: [] as AddressDataLines[],
      dataCurrency: [] as DataMasterCurrency[],
      dataApprover: [] as DataApprover[],
      dataHistoryTimeLine: [] as DetailInternalContract[],
      dataListBillingType: [
        {
          value: "Advanced",
          name: "Advanced",
        },
        {
          value: "Behind",
          name: "Behind",
        },
      ] as OptionBillingType[],
      view: false as boolean,
      form: this.$form.createForm(this, { name: "createInternalContract" }),
      formModal: this.$form.createForm(this, { name: "formModal" }),
      formModalChangePeriod: this.$form.createForm(this, {
        name: "formModalChangePeriod",
        onFieldsChange: (_, changedFields) => {
          if ("newStartRent" in changedFields) {
            this.updateNewRentPeriodRange();
          }
        },
      }),
      formModalChangePrice: this.$form.createForm(this, {
        name: "formModalChangePrice",
      }),
      formModalChangeUnit: this.$form.createForm(this, {
        name: "formModalChangeUnit",
      }),
      formRulesModal: {
        rentPeriod: {
          label: "Rent Period",
          name: "rentPeriod",
          placeholder: "Insert Rent Period",
          decorator: [
            "rentPeriod",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        rentType: {
          label: "Rent Type",
          name: "rentType",
          placeholder: "Insert Rent Type",
          decorator: [
            "rentType",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        notes: {
          label: "Notes",
          name: "notes",
          placeholder: "Insert Notes",
          decorator: [
            "notes",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        withdrawalDate: {
          label: "common.date-text",
          name: "withdrawalDate",
          decorator: [
            "withdrawalDate",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
      formRules: {
        customerName: {
          label: "lbl_customer_name",
          name: "customerName",
          placeholder: "lbl_customer_name_placeholder",
          decorator: [
            "customerName",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        internalContractNo: {
          label: "Internal Contract No",
          name: "internalContractNo",
          placeholder: "<auto generate>",
          decorator: [
            "internalContractNo",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        internalContractDate: {
          label: "Internal Contract Date",
          name: "internalContractDate",
          placeholder: "Insert Internal Contract Date",
          decorator: [
            "internalContractDate",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        branchName: {
          label: "Branch Name",
          name: "branchName",
          placeholder: "Insert Branch Name",
          decorator: [
            "branchName",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        status: {
          label: "Status",
          name: "status",
          placeholder: "Insert Status",
          decorator: [
            "status",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        revised: {
          label: "Revised",
          name: "revised",
          placeholder: "Insert Revised",
          decorator: [
            "revised",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        referenceNo: {
          label: "Reference No",
          name: "referenceNo",
          placeholder: "Insert Reference No",
          decorator: [
            "referenceNo",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        shipTo: {
          label: "Default Ship To",
          name: "shipTo",
          placeholder: "Insert Default Ship To",
          decorator: [
            "shipTo",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        billTo: {
          label: "Bill To",
          name: "billTo",
          placeholder: "Insert Bill To",
          decorator: [
            "billTo",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        picName: {
          label: "PIC Customer",
          name: "picName",
          placeholder: "Insert PIC Customer",
          decorator: [
            "picName",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        currency: {
          label: "lbl_currency",
          name: "currency",
          placeholder: "lbl_currency_placeholder",
          decorator: [
            "currency",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        rentType: {
          label: "Rent Type",
          name: "rentType",
          placeholder: "Insert Rent Type",
          decorator: [
            "rentType",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        rentPeriod: {
          label: "Rent Period",
          name: "rentPeriod",
          placeholder: "Insert Rent Period",
          decorator: [
            "rentPeriod",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        rentStartingDate: {
          label: "Rent Starting Date",
          name: "rentStartingDate",
          placeholder: "Insert Rent Starting Date",
          decorator: [
            "rentStartingDate",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        rentPeriodRange: {
          label: "Rent Period (Range)",
          name: "rentPeriodRange",
          placeholder: "Insert Rent Period (Range)",
          decorator: [
            "rentPeriodRange",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        billingType: {
          label: "Billing Type",
          name: "billingType",
          placeholder: "Insert Billing Type",
          decorator: [
            "billingType",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        termOfCondition: {
          label: "Term Of Condition / Notes",
          name: "termOfCondition",
          placeholder: "Insert Term Of Condition",
          decorator: [
            "termOfCondition",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        fileContract: {
          label: "File Contract",
          name: "fileContract",
          placeholder: "Insert File Contract",
          decorator: [
            "fileContract",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        sales: {
          label: "Sales",
          name: "sales",
          placeholder: "Insert Sales",
          decorator: [
            "sales",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        createdBy: {
          label: "Created By",
          name: "createdBy",
          placeholder: "Insert Created By",
          decorator: [
            "createdBy",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        approver: {
          label: "Approver",
          name: "approver",
          placeholder: "Insert Approver",
          decorator: [
            "approver",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        notes: {
          label: "Notes Approve / Reject / Revised",
          name: "notes",
          placeholder: "Insert Notes",
          decorator: [
            "notes",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        services: {
          label: "lbl_services",
        },
      },
      formRulesChangePeriodModal: {
        newStartRent: {
          label: "lbl_change_period_to",
          name: "newStartRent",
          placeholder: "lbl_change_period_to",
          decorator: [
            "newStartRent",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        reason: {
          label: "lbl_input_change_period_reason",
          name: "reason",
          placeholder: "lbl_input_change_period_reason",
          decorator: [
            "reason",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
      formRulesChangePriceModal: {
        reason: {
          label: "lbl_reason",
          name: "reason",
          placeholder: "lbl_reason",
          decorator: [
            "reason",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
      formRulesChangeUnitModal: {
        replacementDate: {
          label: "lbl_replacement_date",
          name: "replacementDate",
          placeholder: "lbl_replacement_date",
          decorator: [
            "replacementDate",
            {
              rules: [
                {
                  required: true,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
    };
  },
  watch: {
    dataSource: {
      immediate: true,
      deep: true,
      handler() {
        this.dataSource.forEach((dataForeach, index) => {
          if (dataForeach.unitParentId) {
            const findUnitCodeParent = this.tempColumnOption.find(
              dataFind => dataFind.id === dataForeach.unitParentId
            )?.id;
            const findDataByUnitCodeParent = this.dataSource.find(
              dataFind => dataFind.unitCode === findUnitCodeParent
            );

            this.dataSource[index].shipTo = findDataByUnitCodeParent
              ? findDataByUnitCodeParent.shipTo
              : "";
            this.dataSource[index].location = findDataByUnitCodeParent
              ? findDataByUnitCodeParent.location
              : "";
          }
        });
      },
    },
    mode: {
      immediate: true,
      deep: true,
      handler() {
        if (
          this.mode &&
          this.mode.toLocaleLowerCase() === Mode.CREATE &&
          this.$store.state.preferenceStore.dataPreference.length > 0
        ) {
          this.setBaseCurrencyCreate();
        }
      },
    },
    defaultLocationShipTo: {
      immediate: true,
      deep: true,
      handler() {
        this.dataSource = this.dataSource.map(dataMap => {
          if (!dataMap.unitParentId && !dataMap.shipTo) {
            return dataMap;
          } else {
            return { ...dataMap, location: this.defaultLocationShipTo };
          }
        });
      },
    },
    defaultShipTo: {
      immediate: true,
      deep: true,
      handler() {
        this.dataSource = this.dataSource.map(dataMap => {
          if (!dataMap.unitParentId && !dataMap.shipTo) {
            return dataMap;
          } else {
            return { ...dataMap, shipTo: this.defaultShipTo };
          }
        });
      },
    },
    tempColumnOption: {
      immediate: true,
      deep: true,
      handler() {
        if (this.tempColumnOption) {
          this.dataSource = this.dataSource.map(dataMap => {
            return {
              ...dataMap,
              optionCustom: [
                {
                  name: "unitParentId",
                  option: this.tempColumnOption,
                },
              ],
            };
          });
        }
      },
    },
    "$store.state.preferenceStore.dataPreference": {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (
          newValue &&
          newValue.length > 0 &&
          this.mode &&
          this.mode.toLocaleLowerCase() === Mode.CREATE
        ) {
          this.setBaseCurrencyCreate();
        }
      },
    },
    "$store.state.authStore.authData": {
      immediate: true,
      deep: true,
      handler() {
        if (
          this.$store.state.authStore.authData &&
          this.$store.state.authStore.authData.roles
        ) {
          this.listRoles = this.$store.state.authStore.authData.roles;
        }
      },
    },
    rentType: {
      immediate: true,
      deep: true,
      handler() {
        switch (this.rentType) {
          case "Month":
            this.formRules.rentPeriod.label = "Rent Period";
            this.formRulesModal.rentPeriod.label = "Rent Period";
            this.columnsTable[15].title = "Rent Price / Month";
            break;
          case "Day":
            this.formRules.rentPeriod.label = "Rent Period";
            this.formRulesModal.rentPeriod.label = "Rent Period";
            this.columnsTable[15].title = "Rent Price / Day";
            break;
          case "3 Month":
          case "6 Month":
          case "Yearly":
            this.formRules.rentPeriod.label = "Rent Period";
            this.formRulesModal.rentPeriod.label = "Rent Period";
            this.columnsTable[15].title = "Rent Price / Period";
            break;
        }
        this.columnsTable = this.columnsTable.slice();
      },
    },
    detail: {
      immediate: true,
      deep: true,
      handler() {
        if (this.isRevised || this.isNew || this.isDraft) {
          this.view = false;
          this.dataSource = this.dataSource.map(dataMap => {
            return {
              ...dataMap,
              disabledInput: false,
              disabledSelect: false,
              disabledCheckBox: false,
            };
          });
        } else if (
          this.isNeedApproval ||
          this.isEnded ||
          this.isRejected ||
          this.isApproved ||
          this.isPartialEnded ||
          this.isCancelled ||
          this.isClosed
        ) {
          this.view = true;
          this.dataSource = this.dataSource.map(dataMap => {
            return {
              ...dataMap,
              disabledInput: true,
              disabledSelect: true,
              disabledCheckBox: true,
            };
          });
        }
      },
    },
    dataRent: {
      immediate: true,
      deep: true,
      handler(value) {
        if (
          this.rentType === "Month" &&
          value.startingDate &&
          value.rentPeriod
        ) {
          const futureMonth = moment(value.startingDate, "DD-MMM-YYYY")
            .add(value.rentPeriod, "M")
            .subtract(1, "days");
          this.form.setFieldsValue({
            rentPeriodRange: `${value.startingDate} - ${moment(
              futureMonth
            ).format("DD-MMM-YYYY")}`,
          });
        } else if (this.rentType === "Day" && this.dataRent.startingDate) {
          const futureMonth = moment(
            this.dataRent.startingDate,
            "DD-MMM-YYYY"
          ).add(this.dataRent.rentPeriod, "d");
          this.form.setFieldsValue({
            rentPeriodRange: `${this.dataRent.startingDate} - ${moment(
              futureMonth
            ).format("DD-MMM-YYYY")}`,
          });
        } else if (
          (this.rentType === "3 Month" ||
            this.rentType === "6 Month" ||
            this.rentType === "Yearly") &&
          value.startingDate &&
          value.rentPeriod
        ) {
          const monthsMap = { "3 Month": 3, "6 Month": 6, Yearly: 12 };
          const totalMonths = value.rentPeriod * monthsMap[this.rentType];
          const futureDate = moment(value.startingDate, "DD-MMM-YYYY")
            .add(totalMonths, "M")
            .subtract(1, "days");
          this.form.setFieldsValue({
            rentPeriodRange: `${value.startingDate} - ${moment(futureDate).format("DD-MMM-YYYY")}`,
          });
        } else {
          this.form.resetFields(["rentPeriodRange"]);
        }
      },
    },
  },
  methods: {
    moment,
    debounce,
    setDataForm(values): void {
      for (const key in values) {
        this.form.getFieldDecorator(key, {
          initialValue: values[key],
        });
      }
      this.form.setFieldsValue(values);
    },
    disabledSameMonth(current: Moment): boolean {
      const baseDate = moment(
        this.form.getFieldValue("rentStartingDate"),
        "DD-MMM-YYYY"
      );
      return useDisabledSameMonth(current, baseDate);
    },
    disabledWithdrawalDate(current: Moment): boolean {
      const minDate = moment().subtract(7, "days").startOf("day");
      const maxDate = moment().add(3, "days").startOf("day");

      const lastHistory = this.lastHistoryDate
        ? moment(this.lastHistoryDate, DEFAULT_DATE_FORMAT).startOf("day")
        : null;

      const effectiveMin =
        lastHistory && lastHistory.isValid() && lastHistory.isAfter(minDate)
          ? lastHistory
          : minDate;

      return current.isBefore(effectiveMin) || current.isAfter(maxDate);
    },
    setDeleteProductServices(value: any): void {
      this.deleteLineIdProductServices = value;
    },
    setTotalProductServices(value: any): void {
      this.footerTotalProductServices = value;
    },
    setDataSourceProductServices(
      value: CustomDataSourceProductServiceTab[]
    ): void {
      this.dataSourceProductServices = value;
    },
    setBaseCurrencyCreate(): void {
      const tempObject = {
        feature_base_currency: "",
      };
      this.$store.state.preferenceStore.dataPreference.forEach(dataForeach => {
        if (dataForeach.key === "feature_base_currency") {
          tempObject.feature_base_currency = dataForeach.value;
        }
      });
      const params: RequestQueryParamsModel = {
        limit: 10,
        page: 0,
      };
      if (tempObject.feature_base_currency) {
        params.search = `secureId~${tempObject.feature_base_currency}`;
        settingsServices.listOfMasterCurrency(params, "").then(response => {
          this.setDataForm({
            currency: response.data[0].id,
          });
        });
      }
    },
    handleChangeRentType(value: string): void {
      this.rentType = value;

      this.formRules.rentPeriod.label = "Rent Period";
      this.formRulesModal.rentPeriod.label = "Rent Period";

      switch (value) {
        case "Day":
          this.columnsTable[15].title = "Rent Price / Day";
          break;
        case "Month":
          this.columnsTable[15].title = "Rent Price / Month";
          break;
        case "3 Month":
          this.columnsTable[15].title = "Rent Price / 3 Month";
          break;
        case "6 Month":
          this.columnsTable[15].title = "Rent Price / 6 Month";
          break;
        case "Yearly":
          this.columnsTable[15].title = "Rent Price / Period";
          break;
      }
      this.$set(this.columnsTable, 15, { ...this.columnsTable[15] });
    },
    onBlur(value: any, form: string): void {
      if (value.target.value && !this.form.getFieldError(`${form}`)) {
        let dataobj = {} as { [props: string]: string };
        dataobj[form] = this.formatCurrency(value.target.value);
        this.form.setFieldsValue(dataobj);
      }
    },
    onFocus(value: any, form: string): void {
      if (value.target.value && !this.form.getFieldError(`${form}`)) {
        let dataobj = {} as { [props: string]: number };
        dataobj[form] = this.formatCurrencytoNumber(value.target.value);
        this.form.setFieldsValue(dataobj);
      }
    },
    getCheckboxProps: (record: any) => ({
      props: {
        disabled: record.closed,
        name: "endContract",
      },
    }),
    onSelectChange(selectedRowKeys: number[]): void {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleViewHistory(indexHistory: any): void {
      this.viewHistory = true;
      this.dataHistoryTimeLine.forEach((dataForeach, index) => {
        if (indexHistory === index) {
          this.detail.status = dataForeach.status;
          this.detail.actualStatusDocument = dataForeach.status;
          // check duplicate
          this.checkDuplicateDataBranch({
            name: dataForeach.branchName,
            id: "",
          });
          this.assignCustomer(dataForeach);
          this.checkDuplicateDataCurrencyId({
            code: dataForeach.currencyCode,
            id: "",
          });
          this.checkDuplicateDataSales({ name: dataForeach.salesName, id: "" });
          // assign and setfieldsvalue
          this.assignShipTo({ address: dataForeach.shipTo });
          this.assignBillTo({ address: dataForeach.billTo });
          this.assignPicName({ picName: dataForeach.picName });
          // this.assignBillingType({ billingType: dataForeach.billingType }) // karena option hardcode dri FE maka di comment
          this.assignApprover({
            name: dataForeach.approverName,
            id: dataForeach.approverId,
          });

          if (dataForeach.fileContract) {
            const splited = dataForeach.fileContract.split("/");
            this.fileList = [
              {
                url: dataForeach.fileContract,
                uid: "1",
                size: 0,
                name: splited[splited.length - 1],
                type: "",
              },
            ];
          }
          this.dataRent.rentPeriod = dataForeach.rentPeriod;
          this.dataRent.startingDate = moment(dataForeach.startRent).format(
            "DD-MMM-YYYY"
          );
          this.footerCreateInternalContract.total = currencyFormat(
            dataForeach.totalRentPrice
          );
          this.urlForSend = dataForeach.fileContract;

          this.setDataForm({
            internalContractNo: dataForeach.documentNo,
            branchName: dataForeach.branchName,
            referenceNo: dataForeach.referenceNo,
            internalContractDate: moment(dataForeach.contractDate),
            rentPeriod: dataForeach.rentPeriod,
            rentStartingDate: moment(dataForeach.startRent),
            rentPeriodRange: dataForeach.rentPeriodRange,
            termOfCondition: dataForeach.termOfCondition,
            revised: dataForeach.revised,
            createdBy: dataForeach.createdBy,
            notes: dataForeach.notes,
            customerName: dataForeach.customerName,
            shipTo: dataForeach.shipTo,
            billTo: dataForeach.billTo,
            picName: dataForeach.picName,
            currency: dataForeach.currencyCode,
            billingType: dataForeach.billingType,
            sales: dataForeach.salesName,
            status: dataForeach.status,
            approver: dataForeach.approverId,
          });

          this.dataSource = dataForeach.internalContractDetailList.map(
            dataMap => {
              const findColumn = this.columnsTable.find(
                column => column.responsiveColSelect
              )?.responsiveColSelect;
              if (findColumn) {
                const checkData = findColumn[0].options.some(
                  dataSome => dataSome.name === dataMap.unitCode
                );
                if (!checkData)
                  this.assignColumnOption(
                    0,
                    dataMap.unitCode,
                    dataMap.unitCode,
                    dataMap.unitCodeIsParent
                  );
              }
              return {
                id: dataMap.id,
                uom: dataMap.uomUnit,
                rentPrice: currencyFormat(dataMap.rentPrice),
                subTotal: currencyFormat(dataMap.subTotal),
                unitCode: dataMap.unitCode,
                unitCodeBackup: dataMap.unitBackup,
                unitCodeBackupNo: dataMap.unitBackupNumber,
                unitParentId: dataMap.unitParentId,
                equipment: dataMap.equipment,
                merk: dataMap.merk,
                type: dataMap.type,
                qty: currencyFormat(dataMap.qty),
                key: index,
                endContract: dataMap.endContract,
                closed: dataMap.closed,
                idCategory: dataMap.equipment,
                specification: dataMap.specification,
                shipTo: dataMap.shipTo,
                location: dataMap.location as string,
                serialNumber: dataMap.serialNumber as string,
                disabledSelect: this.isActualNew ? false : true,
                disabledInput: this.isActualNew ? false : true,
              };
            }
          );
          this.modalHistoryOpen = false;
          this.actionType = "";
        }
      });
    },
    viewOriginalModalHistory(e: Event): void {
      e.preventDefault();
      this.getDataDetail();
      this.viewHistory = false;
      this.modalHistoryOpen = false;
      this.actionType = "";
    },
    handleCancelModalHistory(): void {
      this.modalHistoryOpen = false;
      this.actionType = "";
    },
    handleCancelModal(): void {
      this.modalOpen = false;
      this.modeModal = "";
      this.actionType = "";
    },
    handleEndContract(): void {
      this.formModal.resetFields();
      this.actionType = "Ended";
      this.modalOpen = true;
      this.modeModal = "Ended";
    },
    handleCancelModalChangePeriod(): void {
      this.modalChangePeriodOpen = false;
      this.modeModal = "";
      this.actionType = "";
    },
    handleCancelModalChangePrice(): void {
      // Intentionally do NOT reset actionType here: closing the reason modal
      // returns to Change Price edit mode (detail.status is still "Change Price"),
      // so the lock must stay to prevent overlapping actions (Change Unit/Location).
      this.modalChangePriceOpen = false;
      this.modeModal = "";
    },
    handleCancelModalChangeUnit(): void {
      this.modalChangeUnitOpen = false;
      this.formModalChangeUnit.resetFields();
      this.actionType = "";
    },
    handleOpenModalChangeUnit(): void {
      this.actionType = "Change Unit";
      this.modalChangeUnitOpen = true;
    },
    handleClickChangeUnit(): void {
      if (this.detail.status === EnumStatus.ChangeUnit && this.view) {
        this.onSubmit(ACTION_TYPE.CHANGE_UNIT);
      } else {
        this.handleOpenModalChangeUnit();
      }
    },
    handleSubmitModalChangeUnit(): void {
      this.formModalChangeUnit.validateFields((err, values) => {
        if (err) return;
        this.replacementDateChangeUnit = moment(values.replacementDate).format(
          "YYYY-MM-DD"
        );
        this.modalChangeUnitOpen = false;
        this.onSubmit(ACTION_TYPE.CHANGE_UNIT);
      });
    },
    disabledDateChangeUnit(current: Moment): boolean {
      const maxDate = moment().add(3, "days").endOf("day");
      if (current.isAfter(maxDate)) return true;

      if (this.minDateChangeUnit) {
        const minDate = moment(this.minDateChangeUnit, "DD-MMM-YYYY");
        if (current.isBefore(minDate, "day")) return true;
      }
      return false;
    },
    handleChangeBranch(id: any): void {
      this.idBranch = id;
      this.getUnitCode("");
    },
    mappingSubTotal(dataMap: any): any {
      return {
        ...dataMap,
        subTotal: currencyFormat(
          new Decimal(changeCurrencytoNumeric(dataMap.qty) || 0)
            .times(new Decimal(changeCurrencytoNumeric(dataMap.rentPrice) || 0))
            .times(this.dataRent.rentPeriod || 0)
        ),
      };
    },
    handleCountingSubTotalListIc(): void {
      this.dataSource = this.dataSource.map(dataMap => {
        return this.mappingSubTotal(dataMap);
      });
      const sumSubTotal = this.dataSource.reduce((current, dataReduce) => {
        return new Decimal(changeCurrencytoNumeric(dataReduce.subTotal))
          .plus(current)
          .toNumber();
      }, 0);
      this.footerCreateInternalContract.total = currencyFormat(
        sumSubTotal || 0
      );
    },
    handleCountingSubTotalProductService(): void {
      this.dataSourceProductServices = this.dataSourceProductServices.map(
        dataMap => {
          return this.mappingSubTotal(dataMap);
        }
      );
      this.detailDataSourceProductServices =
        this.detailDataSourceProductServices.map(dataMap => {
          return this.mappingSubTotal(dataMap);
        });

      const dataProductService =
        this.dataSourceProductServices.length > 0
          ? this.dataSourceProductServices
          : this.detailDataSourceProductServices;

      const sumSubTotalProductService = dataProductService.reduce(
        (current, dataReduce) => {
          return new Decimal(changeCurrencytoNumeric(dataReduce.subTotal))
            .plus(current)
            .toNumber();
        },
        0
      );
      this.footerTotalProductServices = currencyFormat(
        sumSubTotalProductService || 0
      );
    },
    handleChangeRentPeriod(months: number, isModal?: boolean): void {
      if (isModal) {
        const value = this.form.getFieldsValue(["rentPeriod"]) as any;
        this.dataRent.rentPeriod = value.rentPeriod + months;
      } else {
        this.dataRent.rentPeriod = months;
      }
      this.handleCountingSubTotalListIc();
      this.handleCountingSubTotalProductService();
    },
    handleChangeRentStartingDate(date: Date): void {
      if (date) {
        this.dataRent.startingDate = moment(date).format("DD-MMM-YYYY");
      } else {
        this.dataRent.startingDate = "";
      }
    },
    handleChangeShipTo(address: string): void {
      this.form.resetFields(["picName"]);
      const dataFind = this.dataShipTo.find(
        dataAddress => dataAddress.address === address
      )?.location;
      this.defaultLocationShipTo = dataFind ? dataFind : "";
      this.defaultShipTo = address;
      // this.dataPicName = this.dataShipTo.filter((dataAddress) => dataAddress.address === address)
      const findShipto = this.dataShipTo.find(
        dataAddress => dataAddress.address === address
      );
      this.dataPicName =
        findShipto && findShipto.addressDataLines
          ? findShipto.addressDataLines
          : [];
    },
    handleChangeCustomer(id: string): void {
      this.form.resetFields(["shipTo", "billTo", "picName"]);
      this.getDetailContactData(id);
    },
    uploadFile(options: any): void {
      const formData = new FormData();
      formData.append("file", options.file);
      // upload file
      assetsServices
        .createUploadFile(formData, "sales")
        .then(response => {
          options.onSuccess(options);
          this.urlForSend = response.url;
        })
        .catch(err => {
          options.onError(err, options);
        });
    },
    beforeUpload(file: File): number {
      const isLt5M = file.size;
      if (isLt5M >= 5242880) {
        this.$notification.error({
          description: "File must smaller than 5MB!",
          message: "Error",
          duration: 30,
        });
      }
      return isLt5M;
    },
    handleRemove(file: UploadFile): void {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleChangeFileContract(info: any): void {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status !== "uploading") {
        this.uploadProses = true;
      }
      if (info.file.status === "done") {
        this.fileList = info.fileList;
        this.fileList[0] = { ...this.fileList[0], url: this.attachmentFile };
        this.uploadProses = false;
        // this.attachmentFile = info.file.response.url
        this.$notification.success({
          description: `${info.file.name} file uploaded successfully`,
          message: "Success",
          duration: 30,
        });
      } else if (info.file.status === "error") {
        this.uploadProses = true;
        this.$notification.error({
          description: `${info.file.name} file upload failed.`,
          message: "Error",
          duration: 30,
        });
      }
    },
    responseDeleteTable(response: any): void {
      if (this.isRevised || this.isNew || this.isDraft) {
        this.dataSource = this.dataSource.filter((data, index) => {
          if (response.data.key === index && data.id)
            this.deleteLineId.push(data.id);
          return index !== response.data.key;
        });
        this.dataSource.forEach((data, index) => (data.key = index));
        this.dataSource = this.dataSource.slice();
        this.handleCountingSubTotalListIc();
        // delete parent in option while row unit code (parent) is deleted
        this.tempColumnOption = this.tempColumnOption.filter(dataMap => {
          if (
            this.dataSource.some(dataSome => dataSome.unitCode === dataMap.name)
          )
            return dataMap;
          else return;
        });
      } else {
        this.$notification.error({
          message: "Error",
          description: "You can't delete data",
        });
      }
    },
    getListCustomer(valueSearch: string): void {
      const params: RequestQueryParamsModel = {
        limit: 10,
        page: 0,
        search: "customer~true_AND_active~true",
      };
      if (valueSearch)
        params.search += `_AND_firstName~*${valueSearch}*_OR_lastName~*${valueSearch}*`;
      this.loading.listCustomer = true;
      contactServices
        .listContactData(params)
        .then(response => (this.dataListCustomer = response.data))
        .finally(() => (this.loading.listCustomer = false));
    },
    getCurrency(valueSearch: string): void {
      const params: RequestQueryParamsModel = {
        limit: 10,
        page: 0,
      };
      if (valueSearch) params.search = `currencyCode~${valueSearch}`;
      this.loading.currency = true;
      settingsServices
        .listOfMasterCurrency(params, "")
        .then(response => (this.dataCurrency = response.data))
        .finally(() => (this.loading.currency = false));
    },
    getListBillingType(valueSearch: string): void {
      let params: RequestQueryParamsModel = {};
      if (valueSearch) params.search = `abcd`;
      this.loading.billingType = true;
      this.loading.billingType = false;
    },
    getListSales(valueSearch: string): void {
      const params: RequestQueryParamsModel = {
        limit: 10,
        page: 0,
        search: "employee~true_AND_active~true_AND_employeeData.position~Sales",
      };
      if (valueSearch)
        params.search += `_AND_firstName~*${valueSearch}*_OR_lastName~*${valueSearch}*`;
      this.loading.sales = true;
      contactServices
        .listContactData(params)
        .then(response => (this.dataListSales = response.data))
        .finally(() => (this.loading.sales = false));
    },
    getListBranch(valueSearch: string): void {
      const params: RequestQueryParamsModel = {
        limit: 10,
        page: 0,
      };
      if (valueSearch)
        params.search = `name~*${valueSearch}*_OR_address~*${valueSearch}*`;
      this.loading.branchName = true;
      logisticServices
        .listWarehouseBranch(params, "")
        .then(response => (this.dataListBranch = response.data))
        .finally(() => (this.loading.branchName = false));
    },
    getListStatus(valueSearch: string): void {
      let params: RequestQueryParamsModel = {};
      if (valueSearch) params.search = `abcd`;
      this.loading.status = true;
      this.loading.status = false;
    },
    getListRevised(valueSearch: string): void {
      let params: RequestQueryParamsModel = {};
      if (valueSearch) params.search = `abcd`;
      this.loading.revised = true;
      this.loading.revised = false;
    },
    // Detail
    // check Duplicate Data
    checkDuplicateDataBranch({ name, id }: { name: string; id: string }): void {
      let check = false;
      this.dataListBranch.forEach(dataForeach => {
        if (dataForeach.id === id) {
          check = true;
        }
      });
      if (!check) {
        this.dataListBranch = [
          ...this.dataListBranch,
          {
            id,
            name,
            code: "",
            createdDate: "",
            modifiedDate: "",
            address: "",
          },
        ];
      }
    },
    checkDuplicateDataCurrencyId({
      code,
      id,
    }: {
      code: string;
      id: string;
    }): void {
      let check = false;
      this.dataCurrency.forEach(dataForeach => {
        if (dataForeach.id === id) {
          check = true;
        }
      });
      if (!check) {
        this.dataCurrency = [
          ...this.dataCurrency,
          {
            id,
            currencyCode: code,
            description: code,
          },
        ];
      }
    },
    checkDuplicateDataSales({ name, id }: { name: string; id: string }): void {
      let check = false;
      this.dataListSales.forEach(dataForeach => {
        if (dataForeach.id === id) {
          check = true;
        }
      });
      if (!check) {
        this.dataListSales = [
          ...this.dataListSales,
          {
            id,
            fullName: name,
            employeeNumber: "",
            customerNumber: "",
            supplierNumber: "",
            phoneNumber: "",
            email: "",
            active: true,
          },
        ];
      }
    },
    // Just Assign Data
    assignShipTo({ address }: { address: string }): void {
      this.dataShipTo = [
        {
          address,
          country: "",
          cityDistrict: "",
          postalCode: "",
          picName: "",
          picContactNumber: "",
          idCardNumber: "",
          shipTo: true,
          billTo: false,
          primaryShipTo: false,
          primaryBillTo: false,
        },
      ];
    },
    assignBillTo({ address }: { address: string }): void {
      this.dataBillTo = [
        {
          address,
          country: "",
          cityDistrict: "",
          postalCode: "",
          picName: "",
          picContactNumber: "",
          idCardNumber: "",
          shipTo: false,
          billTo: true,
          primaryShipTo: false,
          primaryBillTo: false,
        },
      ];
    },
    assignPicName({ picName }: { picName: string }): void {
      this.dataPicName = [
        {
          picName,
          telephoneNo: "",
          phoneNo: "",
          email: "",
          position: "",
          key: 0,
        },
      ];
    },
    assignBillingType({ billingType }: { billingType: string }): void {
      this.form.setFieldsValue({ billingType });
    },
    assignApprover({ name, id }: { name: string; id: string }): void {
      if (name && id) {
        this.dataApprover = [
          {
            name,
            id,
          },
        ];
      }
    },

    assignColumnOption(
      key: number,
      name: any,
      id: any,
      unitCodeIsParent?: any,
      location: any = ""
    ): void {
      const findColumn = this.columnsTable.find(
        column => column.responsiveColSelect
      )?.responsiveColSelect;
      if (findColumn) {
        findColumn[key].options.push({
          serialNumber: "",
          unitCode: "",
          parentUnitCode: unitCodeIsParent === false ? "parentUnitCode" : "",
          assetLocation: {
            createdDate: "",
            modifiedDate: "",
            id: "",
            name: "",
            warehouse: {
              name: "",
              id: "",
              modifiedDate: "",
              createdDate: "",
              branchWarehouse: {
                createdDate: "",
                modifiedDate: "",
                id: "",
                name: "",
                address: "",
                code: "",
              },
            },
          },
          status: "",
          invoiceNumber: "",
          purchaseOrderNumber: "",
          supplier: "",
          customerName: "",
          customerLocation: "",
          employeeName: "",
          warranty: "",
          model: "",
          originalCost: 0,
          currentCostAsset: "",
          leasingNumber: "",
          leasingValue: 0,
          leasorName: "",
          leasingPeriod: 0,
          totalLeasingCost: 0,
          lifeMonths: 0,
          currentLifeMonths: 0,
          acquisitionDate: "",
          leasing: false,
          depreciate: false,
          type: "",
          capacity: "",
          qrCode: "",
          salvageValue: 0,
          fileAttachment: "",
          id: id,
          // code: '',
          name: name,
          createdDate: "",
          modifiedDate: "",
          assetNo: 0,
          assetCategory: { id: "", segments: [] },
          description: "",
          assetBookId: "",
          customerId: "",
          customerFirstName: "",
          leasingPercent: 0,
          leasingTax: 0,
          unit: "" as never,
          country: "",
          cityDistrict: "",
          postalCode: "",
          address: "",
          picName: "",
          picContactNumber: "",
          idCardNumber: "",
          shipTo: false,
          billTo: false,
          primaryShipTo: false,
          primaryBillTo: false,
          location: location,
          key: findColumn[key].options.length,
        });
      }
    },
    getDetailContactData(customerId: any, selectedAddress?: any): void {
      contactServices.getContactData(customerId).then(responseContactData => {
        this.dataShipTo = responseContactData.addressDataList.filter(
          dataAddress => dataAddress.shipTo
        );
        this.dataBillTo = responseContactData.addressDataList.filter(
          dataAddress => dataAddress.billTo
        );
        this.form.setFieldsValue({
          billTo: this.dataBillTo[0]?.address,
        });
        const findColumn = this.columnsTable.find(
          column => column.responsiveColSelect
        )?.responsiveColSelect;
        if (findColumn) {
          findColumn[2].options = this.dataShipTo.map(dataMap => {
            return { ...dataMap, name: dataMap.address, id: dataMap.address };
          });
        }
        if (selectedAddress) {
          const dataFind = this.dataShipTo.find(
            dataAddress => dataAddress.address === selectedAddress
          )?.location;
          this.defaultLocationShipTo = dataFind ? dataFind : "";
        }
      });
    },
    filterDuplicateWithSameId(dataArray: any): ContactData[] {
      return dataArray.filter(
        (value, index, self) => index === self.findIndex(t => t.id === value.id)
      );
    },
    assignCustomer(response: DetailInternalContract): any {
      const partial = (
        dataListCustomer: any[],
        fieldsUpdate: Partial<ContactData>
      ) => {
        return [...dataListCustomer, fieldsUpdate] as ContactData[];
      };
      this.dataListCustomer = this.filterDuplicateWithSameId(
        partial(this.dataListCustomer, {
          id: response.customerId,
          fullName: response.customerName,
        })
      );
    },
    getDataDetail(): any {
      salesOrderServices
        .getDetailInternalContract(this.idInternalContract)
        .then(async response => {
          this.dataResponseIc = response;
          this.minDateChangeUnit = response.minDate || "";
          this.services = response.service;
          this.detail.status = response.status;
          this.detail.actualStatusDocument = response.status;
          this.detail.isAcceptanceOfOrder = response.isAcceptanceOfOrder;
          this.detail.isAllBastPosted = response.isAllBastPosted;
          this.detail.isSo = response.isSo;
          this.detail.isCanCancel = response.isCanCancel;
          // check duplicate
          this.assignCustomer(response);
          this.checkDuplicateDataBranch({
            name: response.branchName,
            id: response.branchId,
          });
          this.checkDuplicateDataCurrencyId({
            code: response.currencyCode,
            id: response.currencyId,
          });
          this.checkDuplicateDataSales({
            name: response.salesName,
            id: response.salesId,
          });
          // assign and setfieldsvalue
          this.getDetailContactData(response.customerId, response.shipTo);
          this.assignPicName({ picName: response.picName });
          // this.assignBillingType({ billingType: response.billingType }) // karena option hardcode dri FE maka di comment
          this.assignApprover({
            name: response.approverName,
            id: response.approverId,
          });
          // get list unitCode
          this.idBranch = response.branchId;
          const responseUnitCode = await this.getUnitCodeTableDetail();
          const findColumn = this.columnsTable.find(
            column => column.responsiveColSelect
          )?.responsiveColSelect;
          if (findColumn)
            findColumn[0].options = responseUnitCode.map(dataMap => {
              return { ...dataMap, name: dataMap.unitCode };
            });
          this.dataRent.rentPeriod = response.rentPeriod;
          this.dataRent.startingDate = moment(
            response.pendingStartRent
              ? response.pendingStartRent
              : response.startRent
          ).format("DD-MMM-YYYY");
          this.urlForSend = response.fileContract;

          if (
            this.isEnded ||
            this.isRejected ||
            this.isCancelled ||
            this.isClosed
          ) {
            this.viewHistory = true;
          }
          if (response.fileContract) {
            const splited = response.fileContract.split("/");
            this.fileList = [
              {
                url: response.fileContract,
                uid: "1",
                size: 0,
                name: splited[splited.length - 1],
                type: "",
              },
            ];
          }

          this.rentType = response.periodType;
          this.lastHistoryDate = response.lastHistoryDate ?? "";
          this.idBranch = response.branchId;

          this.setDataForm({
            rentType: response.periodType,
            internalContractNo: response.documentNo,
            branchName: response.branchId,
            referenceNo: response.referenceNo,
            internalContractDate: moment(response.contractDate),
            rentPeriod: response.rentPeriod,
            rentStartingDate: response.pendingStartRent
              ? moment(response.pendingStartRent)
              : moment(response.startRent),
            rentPeriodRange: response.pendingRentPeriodRange,
            termOfCondition: response.termOfCondition,
            revised: response.revised,
            createdBy: response.createdBy,
            notes: response.notes,
            customerName: response.customerId,
            shipTo: response.shipTo,
            billTo: response.billTo,
            picName: response.picName,
            currency: response.currencyId,
            billingType: response.billingType,
            sales: response.salesId,
            status: response.status,
            approver: response.approverId,
          });

          // product services
          this.detailFooterTotalProductService =
            response.totalPriceProductService
              ? currencyFormat(response.totalPriceProductService)
              : "";
          const productServicePendingChanges =
            response.pendingPriceChanges &&
            response.pendingPriceChanges.serviceLines
              ? response.pendingPriceChanges.serviceLines
              : [];

          const hasProductServicePendingChanges =
            productServicePendingChanges.length > 0;

          const findPendingProductService = (id: string) =>
            productServicePendingChanges.find(p => p.detailSecureId === id);

          this.detailDataSourceProductServices = response.productServices.map(
            (dataMap, index) => {
              const pendingData = findPendingProductService(dataMap.id);

              const getPrice =
                hasProductServicePendingChanges && pendingData
                  ? pendingData.newRentPrice
                  : dataMap.rentPrice;

              const getSubTotal =
                hasProductServicePendingChanges && pendingData
                  ? new Decimal(pendingData.newRentPrice)
                      .times(dataMap.qty)
                      .times(response.rentPeriod)
                      .toNumber()
                  : dataMap.subTotal;

              return {
                key: index,
                productId: dataMap.productId,
                productName: dataMap.productName,
                productCode: dataMap.productCode,
                qty: currencyFormat(dataMap.qty),
                uom: dataMap.uomUnit,
                rentPrice: currencyFormat(getPrice),
                subTotal: currencyFormat(getSubTotal),
                id: dataMap.id,
                type: dataMap.type,
                disabledSelect: this.isActualNew ? false : true,
                disabledInput: this.isActualNew ? false : true,
                optionCustom: [
                  {
                    name: "productCode",
                    option: [
                      {
                        customCode: dataMap.productCode,
                        customName: dataMap.productName,
                        id: dataMap.productId,
                        name: dataMap.productCode,
                      },
                    ],
                  },
                  {
                    name: "productName",
                    option: [
                      {
                        customCode: dataMap.productCode,
                        customName: dataMap.productName,
                        id: dataMap.productId,
                        name: dataMap.productName,
                      },
                    ],
                  },
                ],
              };
            }
          );

          this.dataSourceProductServices = response.productServices.map(
            (dataMap, index) => {
              const pendingData = findPendingProductService(dataMap.id);

              const getPrice =
                hasProductServicePendingChanges && pendingData
                  ? pendingData.newRentPrice
                  : dataMap.rentPrice;

              const getSubTotal =
                hasProductServicePendingChanges && pendingData
                  ? new Decimal(pendingData.newRentPrice)
                      .times(dataMap.qty)
                      .times(response.rentPeriod)
                      .toNumber()
                  : dataMap.subTotal;

              return {
                key: index,
                productId: dataMap.productId,
                productName: dataMap.productName,
                productCode: dataMap.productCode,
                qty: currencyFormat(dataMap.qty),
                uom: dataMap.uomUnit,
                rentPrice: currencyFormat(getPrice),
                subTotal: currencyFormat(getSubTotal),
                id: dataMap.id,
                type: dataMap.type,
                disabledSelect: this.isActualNew ? false : true,
                disabledInput: this.isActualNew ? false : true,
                optionCustom: [
                  {
                    name: "productCode",
                    option: [
                      {
                        customCode: dataMap.productCode,
                        customName: dataMap.productName,
                        id: dataMap.productId,
                        name: dataMap.productCode,
                      },
                    ],
                  },
                  {
                    name: "productName",
                    option: [
                      {
                        customCode: dataMap.productCode,
                        customName: dataMap.productName,
                        id: dataMap.productId,
                        name: dataMap.productName,
                      },
                    ],
                  },
                ],
              };
            }
          );

          const listInternalContractPendingChanges =
            response.pendingPriceChanges && response.pendingPriceChanges.lines
              ? response.pendingPriceChanges.lines
              : [];
          const hasPendingChanges =
            listInternalContractPendingChanges.length > 0;
          const findPending = (id: string) =>
            listInternalContractPendingChanges.find(
              p => p.detailSecureId === id
            );

          this.dataSource = response.internalContractDetailList.map(
            (dataMap, index) => {
              const pendingData = findPending(dataMap.id);

              const getPrice =
                hasPendingChanges && pendingData
                  ? pendingData.newRentPrice
                  : dataMap.rentPrice;

              const getSubTotal =
                hasPendingChanges && pendingData
                  ? new Decimal(pendingData.newRentPrice)
                      .times(dataMap.qty)
                      .times(response.rentPeriod)
                      .toNumber()
                  : dataMap.subTotal;

              const isOptionExists = (list: any[], value: string) =>
                list.some(item => item.name === value);

              if (
                findColumn &&
                !isOptionExists(findColumn[0].options, dataMap.unitCode)
              ) {
                this.assignColumnOption(
                  0,
                  dataMap.unitCode,
                  dataMap.unitId,
                  dataMap.unitCodeIsParent
                );
              }

              if (
                dataMap.unitCodeParent &&
                !isOptionExists(this.tempColumnOption, dataMap.unitCodeParent)
              ) {
                this.tempColumnOption.push({
                  name: dataMap.unitCodeParent,
                  id: dataMap.unitParentId,
                });
              }

              return {
                disableByRow: dataMap.unitCodeIsParent ? ["unitParentId"] : [],
                uom: dataMap.uomUnit,
                rentPrice: currencyFormat(getPrice),
                subTotal: currencyFormat(getSubTotal),
                unitCode: dataMap.unitId,
                unitCodeBackup: dataMap.unitBackup,
                unitCodeBackupNo: dataMap.unitBackupNumber,
                unitParentId: dataMap.unitParentId,
                equipment: dataMap.equipment,
                merk: dataMap.merk,
                type: dataMap.type,
                qty: currencyFormat(dataMap.qty),
                key: index,
                endContract: dataMap.endContract,
                closed: dataMap.closed,
                idCategory: dataMap.equipment,
                id:
                  hasPendingChanges && pendingData
                    ? pendingData.detailSecureId
                    : dataMap.id,
                shipTo: dataMap.shipTo,
                serialNumber: dataMap.serialNumber as string,
                specification: dataMap.specification,
                location: dataMap.location as string,
                disabledSelect: !this.isActualNew,
                disabledInput: !this.isActualNew,
              };
            }
          );
          const sumTotal = this.dataSource.reduce((acc, row) => {
            return new Decimal(changeCurrencytoNumeric(row.subTotal))
              .plus(acc)
              .toNumber();
          }, 0);
          this.footerCreateInternalContract.total = currencyFormat(sumTotal);
        })
        .catch(error => {
          console.error("getDataDetail failed", error);
        });
    },

    // Method Handle Table
    handleCheckBoxTable(
      checked: boolean,
      key: any,
      nameColCheckbox: any,
      _value: any
    ): void {
      if (checked) {
        this.dataSource[key].subTotal = String(
          Number(this.dataSource[key].qty) *
            Number(this.dataSource[key].rentPrice)
        );
        if (!isNaN(Number(this.dataSource[key].subTotal))) {
          this.dataSource[key].subTotal = currencyFormat(
            this.dataSource[key].subTotal
          );
        }
        this.handleCountingSubTotalListIc();
        this.dataSource[key].qty = currencyFormat(this.dataSource[key].qty);
        this.handleCountingSubTotalListIc();
      }
      this.dataSource[key][nameColCheckbox] = checked;
      this.dataSource = this.dataSource.slice();
    },
    handleInput(
      value: any,
      key: any,
      objectColInput: any,
      objectColName: any,
      onEvent: any
    ): void {
      if (onEvent === "onFocus") {
        this.handleInputOnFocus(value, key, objectColName);
      } else if (onEvent === "onChange") {
        this.handleInputOnChange(value, key, objectColInput, objectColName);
      } else if (onEvent === "onBlur") {
        this.handleInputOnBlur(key);
      }
    },
    handleInputOnFocus(value: any, key: any, objectColName: any): void {
      if (objectColName === "qty") {
        this.dataSource[key].qty = changeCurrencytoNumeric(value);
        this.dataSource[key].rentPrice = changeCurrencytoNumeric(
          this.dataSource[key].rentPrice
        );
      } else if (objectColName === "rentPrice") {
        this.dataSource[key].rentPrice = changeCurrencytoNumeric(value);
        this.dataSource[key].qty = changeCurrencytoNumeric(
          this.dataSource[key].qty
        );
      }
    },
    handleInputOnChange(
      value: any,
      key: any,
      objectColInput: any,
      objectColName: any
    ): void {
      if (objectColName === "qty") {
        const includePalletKayuOrPlastik =
          this.dataSource[key].idCategory
            ?.toLocaleLowerCase()
            .includes("pallet kayu") ||
          this.dataSource[key].idCategory
            ?.toLocaleLowerCase()
            .includes("pallet plastik")
            ? true
            : false;
        // jika category mengandung pallet kayu atau pallet plastik bisa edit qty
        if (
          this.dataSource[key].idCategory &&
          this.dataSource[key].idCategory !== undefined &&
          includePalletKayuOrPlastik
        ) {
          this.dataSource[key][objectColInput.name] = value;
          this.dataSource = this.dataSource.slice();
        }
      } else {
        this.dataSource[key][objectColInput.name] = value;
        this.dataSource = this.dataSource.slice();
      }
    },
    handleInputOnBlur(key: any): void {
      this.dataSource[key].subTotal = currencyFormat(
        new Decimal(this.dataSource[key].qty || 0)
          .times(new Decimal(this.dataSource[key].rentPrice || 0))
          .times(this.dataRent.rentPeriod || 0)
      );
      const sumSubTotal = this.dataSource.reduce((current, dataReduce) => {
        return new Decimal(changeCurrencytoNumeric(dataReduce.subTotal))
          .plus(current)
          .toNumber();
      }, 0);
      this.footerCreateInternalContract.total = currencyFormat(
        sumSubTotal || 0
      );
      this.dataSource[key].qty = currencyFormat(this.dataSource[key].qty);
      this.dataSource[key].rentPrice = currencyFormat(
        this.dataSource[key].rentPrice
      );
    },
    handleSelect(value: any, key: any, col: any): void {
      this.dataSource[key] = { ...this.dataSource[key], [col]: value };
      this.dataSource = this.dataSource.slice();
      if (col === "unitCode") {
        const paramsParent: RequestQueryParamsModel = {};

        const findColumn = this.columnsTable.find(
          column => column.responsiveColSelect
        )?.responsiveColSelect;
        if (findColumn) {
          const dataFind = findColumn[0].options.find(
            findData => findData.id === value
          );
          paramsParent.search = `parentUnitCode~${dataFind?.unitCode}`;

          if (!dataFind?.parentUnitCode) {
            // jika parent
            this.dataSource[key].disableByRow = ["unitParentId"];
            const checkData = this.tempColumnOption.some(
              dataSome => dataSome.name === dataFind?.name
            );
            if (!checkData)
              this.tempColumnOption.push({
                name: dataFind?.unitCode,
                id: dataFind?.id,
              });
            this.tempColumnOption = this.tempColumnOption.filter(dataFilter =>
              this.dataSource.some(
                dataSome => dataSome.unitCode === dataFilter.id
              )
            );
          } else {
            // jika child
            this.dataSource[key].shipTo = "";
            this.dataSource[key].location = "";
            this.dataSource[key].disableByRow = ["shipTo"];
            this.tempColumnOption = this.tempColumnOption.filter(dataFilter =>
              this.dataSource.some(
                dataSome => dataSome.unitCode === dataFilter.id
              )
            );
          }

          this.dataSource[key].equipment = dataFind?.assetCategory.segments[0]
            .first as string;
          this.dataSource[key].merk = dataFind?.assetCategory.segments[1]
            .first as string;
          this.dataSource[key].type = dataFind?.type as string;
          this.dataSource[key].serialNumber = dataFind?.serialNumber as string;
          this.dataSource[key].specification = dataFind?.description as string;
          this.dataSource[key].uom = dataFind?.uomName || ("" as string);
          this.dataSource[key].idCategory = dataFind?.assetCategory.id;
          this.dataSource[key].qty = "1";
          this.dataSource[key].unitParentId = null;
          this.handleInput("1", key, { name: "qty" }, "qty", "onFocus");
          this.handleInput("1", key, { name: "qty" }, "qty", "onChange");
          this.handleInput("1", key, { name: "qty" }, "qty", "onBlur");
          this.columnsTable = this.columnsTable.slice();
          this.dataSource = this.dataSource.slice();
        }
      }
      if (col === "shipTo") {
        const findShipTo = this.dataShipTo.find(
          dataFind => dataFind.address === value
        );
        this.dataSource[key].location = findShipTo
          ? (findShipTo.location as string)
          : "";
      }
    },
    handleSearchSelectTable(value: any, _key: any, colName: string): void {
      switch (colName) {
        case "unitCode":
          debounce(() => this.getUnitCode(value), 400);
          break;
        case "equipment":
          // this.getListProduct(value)
          break;
        case "merk":
          // this.getListOfBaseUnit(value)
          break;
        case "type":
          // this.getListOfBaseUnit(value)
          break;
        // tinggal kasih case klo ada column baru
        default:
          break;
      }
    },

    // GET TABLE
    getUnitCode(valueSearch: string): void {
      const { findAllAssetRent } = useAsset();
      const INCLUDE_STATUS = "RENTED,READY,NEED_TO_REPAIR";
      if (this.idBranch) {
        const params: RequestQueryParamsModel = {
          limit: 10,
          page: 0,
          status: INCLUDE_STATUS,
          byUser: false,
        };
        if (valueSearch) {
          params.unitCode = valueSearch;
        }
        const findColumn = this.columnsTable.find(
          column => column.responsiveColSelect
        )?.responsiveColSelect;
        if (findColumn) findColumn[0].loading = true;
        findAllAssetRent(params)
          .then(response => {
            if (findColumn) {
              /**
                this variable to store data before map with the purpose to store data unit code in dataSource
               **/
              const tempDataOptionSelected = findColumn[0].options
                .filter(dataFilter =>
                  this.dataSource.some(
                    dataSome => dataSome.unitCode === dataFilter.id
                  )
                )
                .slice();
              findColumn[0].options = response.map(dataMap => {
                return { ...dataMap, name: dataMap.unitCode };
              });
              findColumn[0].options = [
                ...findColumn[0].options,
                ...tempDataOptionSelected,
              ]
                .filter(dataFilter => dataFilter !== undefined)
                .filter(
                  (dataFilter, index, self) =>
                    index === self.findIndex(t => t.id === dataFilter.id)
                );
            }
          })
          .finally(() => {
            if (findColumn) findColumn[0].loading = false;
          });
      } else {
        this.$notification.error({
          message: "Error",
          description: "Select Branch First to get unitCode",
        });
      }
    },
    getUnitCodeTableDetail(): Promise<AssetResponseDto[]> {
      const { findAllAssetRent } = useAsset();
      const INCLUDE_STATUS = "RENTED,READY,NEED_TO_REPAIR";
      const params: RequestQueryParamsModel = {
        limit: 10,
        page: 0,
        status: INCLUDE_STATUS,
        byUser: false,
      };
      return findAllAssetRent(params);
    },
    onRangePickerChange(dates: Array<any>): void {
      if (!dates.length) {
        this.modelForm.date = undefined;
      }
    },
    handleBack(): void {
      this.$confirm({
        title: this.$t("lbl_leave_page"),
        onOk: () => {
          this.$router.push("/sales/internal-contract/list");
        },
        onCancel() {
          return;
        },
      });
    },
    handleCancel(): void {
      if (this.detail.status === EnumStatus.New) {
        this.modelForm.date = [];
        this.dataSource = [];
        this.footerCreateInternalContract.total = 0;
        this.form.resetFields();
      } else if (this.detail.isCanCancel) {
        this.$confirm({
          title: `Are you sure want to cancel?`,
          onOk: () => {
            const icNumber = this.form.getFieldsValue(["internalContractNo"]);
            salesOrderServices
              .cancelInternalContract(this.idInternalContract)
              .then(() => {
                this.$notification.success({
                  description: `Internal Contract Number: ${icNumber.internalContractNo} Success Cancelled`,
                  message: "Success",
                  duration: 30,
                });
                this.$router.push("/sales/internal-contract/list");
              });
          },
          onCancel() {
            return;
          },
        });
      }
    },
    handleAddRow(): void {
      this.dataSource = [
        ...this.dataSource,
        {
          key: this.dataSource.length,
          unitCode: "",
          unitCodeBackup: false,
          unitParentId: null,
          unitCodeBackupNo: "",
          equipment: "",
          merk: "",
          type: "",
          qty: "1",
          uom: "",
          rentPrice: "0",
          closed: false,
          subTotal: "",
          endContract: false,
          serialNumber: "",
          specification: "",
          location: this.defaultLocationShipTo,
          shipTo: this.defaultShipTo,
          id: "",
          optionCustom: [
            {
              name: "unitParentId",
              option: this.tempColumnOption,
            },
          ],
        },
      ];
    },
    disabledDate(current: Moment): boolean {
      return current > moment().endOf("day");
    },
    handleSelectType(value: string): void {
      this.form.setFieldsValue({
        adj: value,
      });
    },
    handleCheckString(value: string): string {
      if (value) return value;
      else return "";
    },
    assignSearch(key: any, value: any, and: any): string {
      if (key === "no" && value) return and + `documentNumber~${value}`;
      else if (key === "location" && value)
        return and + `warehouseLocation.secureId~${value}`;
      else if (key === "adj" && value)
        return and + `type~${value.replace(" ", "_").toUpperCase()}`;
      else return "";
    },
    dynamicSearch(res: any): string {
      let search = "";
      Object.keys(res).forEach(key => {
        if (!search) {
          search = this.assignSearch(key, res[key], "");
        } else {
          search += this.assignSearch(key, res[key], "_AND_");
        }
      });
      return search;
    },
    Allvalidation(): boolean {
      // true jika ada error
      let tempError: string[] = [];
      if (this.services) {
        if (this.dataSourceProductServices.length === 0)
          tempError.push("Tab Product at least have 1 data");
      } else {
        if (this.dataSource.length === 0)
          tempError.push("Tab Unit Code at least have 1 data");
      }

      this.dataSourceProductServices.forEach(dataForeach => {
        if (
          !dataForeach.productId ||
          !dataForeach.productName ||
          !dataForeach.productCode
        ) {
          tempError.push("Product can't empty");
        }
        if (changeCurrencytoNumeric(dataForeach.qty) < 1) {
          tempError.push("Qty cannot be less than equal to 0");
        }
        if (changeCurrencytoNumeric(dataForeach.rentPrice) < 1) {
          tempError.push("Rent Price cannot be less than equal to 0");
        }
      });

      const checkDataSource = this.dataSource.some(
        dataSome => !dataSome.shipTo
      );
      const checkChild = this.dataSource.some(
        dataSome => !dataSome.shipTo && !dataSome.unitParentId
      );
      if (checkChild) {
        tempError.push(
          "Ship to & parent (unit child) in List of Internal Contract can't empty"
        );
      } else if (checkDataSource) {
        tempError.push("Ship to in List of Internal Contract can't empty");
      }

      this.dataSource.forEach(dataForeach => {
        if (changeCurrencytoNumeric(dataForeach.qty) < 1) {
          tempError.push("Qty cannot be less than equal to 0");
        }
        // child boleh 0 makanya checkChild harus false dlu
        if (
          !checkChild &&
          !dataForeach.unitParentId &&
          !dataForeach.unitCodeBackup &&
          changeCurrencytoNumeric(dataForeach.rentPrice) < 1 &&
          !dataForeach.endContract
        ) {
          tempError.push("Rent Price cannot be less than equal to 0");
        }
      });

      if (tempError.length > 0) {
        tempError = [...new Set(tempError)];
        tempError.forEach(dataForeach => {
          debounce(() => {
            this.$notification.error({
              message: "Error",
              description: dataForeach,
            });
          }, 20);
        });
        return true;
      } else {
        return false;
      }
    },
    createInternalContract(payload: RequestInternalContract): void {
      salesOrderServices
        .postInternalContract(payload)
        .then(response => {
          if (response)
            this.$notification.success({
              description: `Internal Contract Number: ${response}`,
              message: "Success",
              duration: 30,
            });
          else
            this.$notification.success({
              description: "Success save as draft",
              message: "Success",
              duration: 30,
            });
          this.$router.push("/sales/internal-contract/list");
        })
        .finally(() => {
          this.actionType = ACTION_TYPE.NONE;
          this.loading.table = false;
        });
    },
    updateInternalContract(payload: any, id: string): void {
      salesOrderServices
        .putInternalContract(payload, id)
        .then(response => {
          this.$notification.success({
            description: `Internal Contract Number: ${response}`,
            message: "Success",
            duration: 30,
          });
          this.replacementDateChangeUnit = "";
          this.$router.push("/sales/internal-contract/list");
        })
        .finally(() => {
          this.actionType = ACTION_TYPE.NONE;
          this.loading.table = false;
          this.loading.submitFormModal = false;
        });
    },
    isActionDisabled(type: string): boolean {
      return (
        this.detail.status === EnumStatus.NeedApproval ||
        (!!this.actionType && this.actionType !== type) ||
        this.loading.closeUnits
      );
    },
    isActionDisabledApproveReject(type: string): boolean {
      return !!this.actionType && this.actionType !== type;
    },
    handleCloseUnits(): void {
      const { closeUnits } = useInternalContract();
      const selectedRows = (this.selectedRowKeys as number[]).map(
        idx => this.dataSource[idx]
      );
      const isEligible = selectedRows.every(
        row => row.endContract && !row.closed
      );
      if (!this.isPartialEnded || !isEligible) {
        this.$notification.error({
          message: "Error",
          description: "Select ended units only to close IC",
        });
        return;
      }
      const detailIds = selectedRows.map(row => row.id);
      this.loading.closeUnits = true;
      closeUnits(this.idInternalContract, { detailIds })
        .then(() => {
          this.showNotifSuccess("notif_success_close_units");
          this.getDataDetail();
          this.selectedRowKeys = [];
        })
        .catch(() => {
          this.showNotifError("notif_process_fail");
        })
        .finally(() => {
          this.loading.closeUnits = false;
        });
    },
    updateNewRentPeriodRange(): void {
      const changePeriod =
        this.formModalChangePeriod.getFieldValue("newStartRent");
      if (!changePeriod) {
        this.newRentPeriodRangeDisplay = "";
        return;
      }
      const monthsMap = { Month: 1, "3 Month": 3, "6 Month": 6, Yearly: 12 };
      const monthsFactor = monthsMap[this.rentType];
      if (monthsFactor && this.form.getFieldValue("rentPeriod")) {
        const totalMonths =
          this.form.getFieldValue("rentPeriod") * monthsFactor;
        const end = changePeriod
          .clone()
          .add(totalMonths, "M")
          .subtract(1, "days");
        this.newRentPeriodRangeDisplay = `${changePeriod.format(DEFAULT_DATE_FORMAT)} - ${end.format(DEFAULT_DATE_FORMAT)}`;
        return;
      }
      const end = moment(this.dataRent.startingDate, DEFAULT_DATE_FORMAT).add(
        this.dataRent.rentPeriod,
        "d"
      );
      this.newRentPeriodRangeDisplay = `${changePeriod.format(DEFAULT_DATE_FORMAT)} - ${end.format(DEFAULT_DATE_FORMAT)}`;
    },
    async onSubmit(
      type: string,
      additionStatus?:
        | "Approved"
        | "Rejected"
        | "Extended"
        | "Ended"
        | "Change Period"
        | "Change Price"
        | "Need Approval"
    ): Promise<void> {
      try {
        this.actionType = type;
        if (type === ACTION_TYPE.UPDATE) {
          this.view = false;
          this.detail.status = EnumStatus.Revised;
          this.actionType = "";
        } else if (type === ACTION_TYPE.HISTORY) {
          const params: RequestQueryParamsModel = {
            limit: 1000,
            page: 0,
            search: `internalContract.secureId~${this.idInternalContract}`,
            sorts: "createdDate:desc",
          };
          this.modalHistoryOpen = true;
          salesOrderServices
            .getDetailHistoryInternalContract(params)
            .then(response => {
              this.dataHistoryTimeLine = response.data;
            });
        } else if (!this.Allvalidation()) {
          this.form.validateFields((err, res) => {
            if (err) {
              this.actionType = "";
              return;
            }
            let countEndContract = 0;
            let sumSubTotal = 0;
            const payload: RequestInternalContract = {
              periodType: this.rentType,
              branchId: this.handleCheckString(res.branchName),
              referenceNo: this.handleCheckString(res.referenceNo),
              contractDate: res.internalContractDate
                ? moment(res.internalContractDate).format("YYYY-MM-DD")
                : "",
              customerId: this.handleCheckString(res.customerName),
              shipTo: this.handleCheckString(res.shipTo),
              billTo: this.handleCheckString(res.billTo),
              picName: this.handleCheckString(res.picName),
              currencyId: this.handleCheckString(res.currency),
              rentPeriod: res.rentPeriod,
              rentType: res.rentType,
              startRent: moment(res.rentStartingDate).format("YYYY-MM-DD"),
              // endRent: moment(res.rentPeriodRange?.split(' - ')[1]).format('YYYY-MM-DD'),
              endRent: moment(
                res.rentPeriodRange?.split(" - ")[1],
                "DD-MMM-YYYY"
              ).format("YYYY-MM-DD"),
              // endRent: res.rentPeriodRange?.split(' - ')[1],
              billingType: this.handleCheckString(res.billingType),
              termOfCondition: this.handleCheckString(res.termOfCondition),
              fileContract: this.urlForSend,
              salesId: this.handleCheckString(res.sales),
              service: this.services,
              status: type, // Draft / new / Need Approval / approved / rejected / revised / ended
              approverId: "",
              reason: "",
              newStartRent: "",
              replacementDate: this.replacementDateChangeUnit || "",
              notes: res.notes,
              deleteLineId: this.deleteLineId.concat(
                this.deleteLineIdProductServices
              ),
              total:
                changeCurrencytoNumeric(
                  this.footerCreateInternalContract.total
                ) + changeCurrencytoNumeric(this.footerTotalProductServices), // sub total di sum,
              productServices: this.dataSourceProductServices.map(dataMap => {
                return {
                  productServiceId: dataMap.id,
                  productId: dataMap.productId,
                  type: dataMap.type,
                  rentPrice: changeCurrencytoNumeric(dataMap.rentPrice),
                  subTotal: changeCurrencytoNumeric(dataMap.subTotal),
                  qty: changeCurrencytoNumeric(dataMap.qty),
                  uom: dataMap.uom,
                };
              }),
              contractDetails: this.dataSource
                .map(dataMap => {
                  return {
                    unitParentId: dataMap.unitParentId,
                    unitId: dataMap.unitCode,
                    unitBackup: dataMap.unitCodeBackup,
                    equipment: dataMap.equipment,
                    merk: dataMap.merk,
                    type: dataMap.type,
                    qty: changeCurrencytoNumeric(dataMap.qty),
                    uom: dataMap.uom,
                    rentPrice: changeCurrencytoNumeric(dataMap.rentPrice),
                    subTotal: changeCurrencytoNumeric(dataMap.subTotal),
                    endContract: dataMap.endContract ? true : false,
                    id: dataMap.id,
                    location: dataMap.location,
                    shipTo: dataMap.shipTo,
                  };
                })
                .filter(
                  dataFilter =>
                    dataFilter.unitId ||
                    dataFilter.unitBackup ||
                    dataFilter.equipment ||
                    dataFilter.merk ||
                    dataFilter.type ||
                    dataFilter.qty ||
                    dataFilter.uom ||
                    dataFilter.rentPrice
                ),
            };
            switch (type) {
              case ACTION_TYPE.DRAFT:
                this.loading.table = true;
                payload.endRent = moment(payload.endRent)
                  .set({ hour: 8, minute: 0, second: 0 })
                  .utcOffset("+07")
                  .format();
                this.createInternalContract(payload);
                break;
              case ACTION_TYPE.NEED_APPROVAL:
                this.loading.table = true;
                payload.endRent = moment(payload.endRent)
                  .set({ hour: 8, minute: 0, second: 0 })
                  .utcOffset("+07")
                  .format();
                if (this.isDraft) {
                  this.updateInternalContract(payload, this.idInternalContract);
                } else if (this.isNew) {
                  this.createInternalContract(payload);
                }
                break;
              case ACTION_TYPE.CHANGE_UNIT:
                if (this.detail.status === EnumStatus.ChangeUnit) {
                  this.updateInternalContract(payload, this.idInternalContract);
                } else {
                  this.detail.status = EnumStatus.ChangeUnit;
                  this.dataSource = this.dataSource.map(dataMap => {
                    return {
                      ...dataMap,
                      disabledSelect: dataMap.endContract ? true : false,
                    };
                  });
                }
                break;
              case ACTION_TYPE.CHANGE_LOCATION:
                if (this.detail.status === EnumStatus.ChangeLocation) {
                  this.updateInternalContract(payload, this.idInternalContract);
                } else {
                  this.detail.status = EnumStatus.ChangeLocation;
                  this.dataSource = this.dataSource.map(dataMap => {
                    if (dataMap.unitParentId) {
                      return {
                        ...dataMap,
                        disableByRow: ["shipTo", "unitCode", "unitParentId"],
                        disabledSelect: false,
                      };
                    } else {
                      return {
                        ...dataMap,
                        disabledSelect: false,
                        disableByRow: ["unitCode", "unitParentId"],
                      };
                    }
                  });
                  // ini oii
                }
                break;
              case ACTION_TYPE.APPROVE_REJECTED:
                if (!additionStatus) {
                  this.modalOpen = true;
                  this.modeModal = "approve/rejected";
                } else {
                  this.formModal.validateFields((errModal, responseModal) => {
                    if (errModal) return;
                    payload.endRent = moment(payload.endRent)
                      .set({ hour: 8, minute: 0, second: 0 })
                      .utcOffset("+07")
                      .format();
                    payload.status = additionStatus;
                    payload.notes = responseModal.notes;
                    this.loading.table = true;
                    this.loading.submitFormModal = true;
                    this.updateInternalContract(
                      payload,
                      this.idInternalContract
                    );
                  });
                }
                break;
              case ACTION_TYPE.EXTEND:
                if (!additionStatus) {
                  this.modeModal = "Extend";
                  this.modalOpen = true;
                  this.$nextTick(() => {
                    this.formModal.setFieldsValue({
                      rentPeriod: undefined,
                      rentType: this.rentType,
                    });
                  });
                } else {
                  this.formModal.validateFields((errorModal, responseModal) => {
                    if (errorModal) return;
                    payload.status = additionStatus;
                    payload.notes = responseModal.notes;
                    payload.rentPeriod += responseModal.rentPeriod;
                    payload.rentType = responseModal.rentType;
                    if (this.rentType === "Month") {
                      payload.endRent = moment(
                        payload.endRent,
                        "YYYY-MM-DD"
                      ).format("YYYY-MM-DD");
                    }
                    if (this.rentType === "Day") {
                      payload.endRent = moment(
                        payload.endRent,
                        "YYYY-MM-DD"
                      ).format("YYYY-MM-DD");
                    }

                    const sumSubTotalTable = this.dataSource.reduce((a, b) => {
                      return a + changeCurrencytoNumeric(b.subTotal);
                    }, 0);
                    const dataProductService =
                      this.dataSourceProductServices.length > 0
                        ? this.dataSourceProductServices
                        : this.detailDataSourceProductServices;
                    const sumSubTotalProductService = dataProductService.reduce(
                      (a, b) => {
                        return a + changeCurrencytoNumeric(b.subTotal);
                      },
                      0
                    );

                    payload.total =
                      sumSubTotalTable + sumSubTotalProductService;
                    payload.endRent = moment(payload.endRent)
                      .set({ hour: 8, minute: 0, second: 0 })
                      .utcOffset("+07")
                      .format();
                    this.loading.table = true;
                    this.loading.submitFormModal = true;
                    this.updateInternalContract(
                      payload,
                      this.idInternalContract
                    );
                  });
                }
                break;
              case ACTION_TYPE.REVISED:
                this.loading.table = true;
                payload.endRent = moment(payload.endRent)
                  .set({ hour: 8, minute: 0, second: 0 })
                  .utcOffset("+07")
                  .format();
                this.updateInternalContract(payload, this.idInternalContract);
                break;
              case ACTION_TYPE.ENDED:
                if (!additionStatus) {
                  this.modalOpen = true;
                  this.modeModal = "Ended";
                } else {
                  this.formModal.validateFields((errModal, responseModal) => {
                    if (errModal) return;
                    payload.notes = responseModal.notes;
                    payload.withdrawalDate = responseModal.withdrawalDate
                      ? moment(responseModal.withdrawalDate).format(
                          DATE_FORMAT_YYYY_MM_DD
                        )
                      : "";
                    const hasAlreadyEnded = (
                      this.selectedRowKeys as number[]
                    ).some(idx => this.dataSource[idx].endContract);
                    if (this.selectedRowKeys.length > 0 && !hasAlreadyEnded) {
                      payload.contractDetails = payload.contractDetails.map(
                        (dataMap, index) => {
                          if (dataMap.endContract) countEndContract++;
                          if (this.selectedRowKeys.includes(index)) {
                            countEndContract++;
                            return {
                              ...dataMap,
                              endContract: true,
                              qty: 0,
                              rentPrice: 0,
                              subTotal: 0,
                            };
                          } else {
                            return dataMap.endContract
                              ? dataMap
                              : { ...dataMap, endContract: false };
                          }
                        }
                      );

                      if (countEndContract === payload.contractDetails.length)
                        payload.status = "Ended";
                      if (countEndContract < payload.contractDetails.length)
                        payload.status = "Partial Ended";

                      payload.contractDetails.forEach(dataForeach => {
                        sumSubTotal += dataForeach.subTotal;
                      });

                      payload.total = sumSubTotal;
                      payload.endRent = moment(payload.endRent)
                        .set({ hour: 8, minute: 0, second: 0 })
                        .utcOffset("+07")
                        .format();
                      this.loading.submitFormModal = true;
                      this.updateInternalContract(
                        payload,
                        this.idInternalContract
                      );
                    } else if (hasAlreadyEnded) {
                      this.$notification.error({
                        message: "Error",
                        description:
                          "Unit yang sudah ended tidak boleh ikut dipilih",
                      });
                    } else {
                      this.$notification.error({
                        message: "Error",
                        description: "Select data first to end contract",
                      });
                    }
                  });
                }
                break;
              case ACTION_TYPE.CHANGE_PERIOD:
                if (!additionStatus) {
                  this.modalChangePeriodOpen = true;
                  this.modeModal = "Change Period";
                } else {
                  this.formModalChangePeriod.validateFields(
                    (errModal, responseModal) => {
                      if (errModal) return;
                      payload.newStartRent = moment(
                        responseModal.newStartRent
                      ).format("YYYY-MM-DD");
                      payload.status = additionStatus;
                      payload.reason = responseModal.reason;

                      this.updateInternalContract(
                        payload,
                        this.idInternalContract
                      );
                    }
                  );
                }
                break;
              case ACTION_TYPE.CHANGE_PRICE:
                if (
                  this.detail.status !== EnumStatus.ChangePrice &&
                  !additionStatus
                ) {
                  this.dataSource = this.dataSource.map(dataMap => {
                    return {
                      ...dataMap,
                      disabledInput: false,
                    };
                  });
                  this.detailDataSourceProductServices =
                    this.detailDataSourceProductServices.map(productService => {
                      return {
                        ...productService,
                        disabledInput: false,
                      };
                    });

                  this.detailDataSourceProductServices =
                    this.detailDataSourceProductServices.map(productService => {
                      return {
                        ...productService,
                        disabledInput: false,
                      };
                    });

                  this.detail.status = EnumStatus.ChangePrice;

                  return;
                }

                if (
                  this.detail.status === EnumStatus.ChangePrice &&
                  !additionStatus
                ) {
                  this.modalChangePriceOpen = true;
                  this.modeModal = "Change Price";

                  return;
                }

                if (additionStatus) {
                  this.formModalChangePrice.validateFields(
                    (errModal, responseModal) => {
                      if (errModal) return;

                      this.loading.submitFormModalChangePrice = true;
                      this.modalChangePriceOpen = false;

                      payload.status = additionStatus;
                      payload.reason = responseModal.reason;

                      this.updateInternalContract(
                        payload,
                        this.idInternalContract
                      );
                    }
                  );
                }
                break;
              default:
                break;
            }
          });
        } else {
          this.actionType = "";
        }
      } catch (error) {
        this.actionType = "";
        this.$notification.error({
          description: Messages.CREATE_FAIL,
          message: "Error",
          duration: 30,
        });
      }
    },
    filterOption(input: any, option: any): any {
      return (
        option.componentOptions.children[0].componentOptions.children[1].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
      };
    },
    // status can change
    isNew(): boolean {
      return this.detail.status === EnumStatus.New;
    },
    isDraft(): boolean {
      return this.detail.status === EnumStatus.Draft;
    },
    isNeedApproval(): boolean {
      return this.detail.status === EnumStatus.NeedApproval;
    },
    isRejected(): boolean {
      return this.detail.status === EnumStatus.Rejected;
    },
    isRevised(): boolean {
      return this.detail.status === EnumStatus.Revised;
    },
    isEnded(): boolean {
      return this.detail.status === EnumStatus.Ended;
    },
    isApproved(): boolean {
      return this.detail.status === EnumStatus.Approved;
    },
    isPartialEnded(): boolean {
      return this.detail.status === EnumStatus.PartialEnded;
    },
    canCloseUnits(): boolean {
      return (
        this.selectedRowKeys.length > 0 &&
        (this.selectedRowKeys as number[]).every(
          idx =>
            this.dataSource[idx].endContract && !this.dataSource[idx].closed
        )
      );
    },
    canEndContract(): boolean {
      return (
        this.selectedRowKeys.length > 0 &&
        (this.selectedRowKeys as number[]).every(
          idx => !this.dataSource[idx].endContract
        )
      );
    },
    isChangeUnit(): boolean {
      return this.detail.status === EnumStatus.ChangeUnit;
    },
    isChangeLocation(): boolean {
      return this.detail.status === EnumStatus.ChangeLocation;
    },
    isAcceptanceOfOrder(): boolean {
      return this.detail.isAcceptanceOfOrder;
    },
    isAllBastPosted(): boolean {
      return this.detail.isAllBastPosted;
    },
    isSo(): boolean {
      return this.detail.isSo;
    },
    isCancelled(): boolean {
      return this.detail.status === EnumStatus.Cancelled;
    },
    isClosed(): boolean {
      return this.detail.status === EnumStatus.Closed;
    },
    // status can't change actual in document
    isActualNew(): boolean {
      return this.detail.actualStatusDocument === EnumStatus.New;
    },
    isActualDraft(): boolean {
      return this.detail.actualStatusDocument === EnumStatus.Draft;
    },
    isActualNeedApproval(): boolean {
      return this.detail.actualStatusDocument === EnumStatus.NeedApproval;
    },
    isShowChangePrice(): boolean {
      return (
        this.rentType !== "Day" &&
        this.isAcceptanceOfOrder &&
        this.$can("change-price", "internal-contract")
      );
    },
    isShowChangePeriod(): boolean {
      return (
        this.rentType !== "Day" &&
        this.isAcceptanceOfOrder &&
        this.$can("change-period", "internal-contract")
      );
    },
  },
  created() {
    this.mode = this.$route.meta.mode;
    this.idInternalContract = this.$route.params.id;
    this.getListCustomer("");
    this.getCurrency("");
    this.getListBillingType("");
    this.getListSales("");
    this.getListRevised("");
    this.getListBranch("");
    this.getListStatus("");
  },
  mounted() {
    switch (this.mode) {
      case Mode.CREATE:
        this.detail.status = EnumStatus.New;
        this.setDataForm({
          billingType: "Behind",
        });
        break;
      case Mode.VIEW:
        this.getDataDetail();
        break;
      default:
        break;
    }
  },
});
